var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.85714C5.64581 2.85714 2.8125 4.68914 2.8125 6.85714C2.8125 7.01486 2.9385 7.14286 3.09375 7.14286C3.249 7.14286 3.375 7.01486 3.375 6.85714C3.375 5.03086 6.00356 3.42857 9 3.42857C9.15469 3.42857 9.28125 3.30057 9.28125 3.14286C9.28125 2.98514 9.15525 2.85714 9 2.85714Z",
    fill: "#7F7F7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02919 0 0 3.07029 0 6.85714C0 9.21543 1.56319 11.2949 3.942 12.5291C3.942 12.5446 3.9375 12.5549 3.9375 12.5714C3.9375 13.596 3.18431 14.6989 2.853 15.2777H2.85412C2.82769 15.3406 2.8125 15.4097 2.8125 15.4823C2.8125 15.768 3.04031 16 3.32213 16C3.375 16 3.46781 15.9857 3.46556 15.992C5.22337 15.6994 6.87937 14.0589 7.26412 13.5834C7.82606 13.6674 8.40544 13.7143 9 13.7143C13.9697 13.7143 18 10.644 18 6.85714C18 3.07029 13.9703 0 9 0ZM9 12.5714C8.48419 12.5714 7.95488 12.5314 7.42725 12.4531C7.37269 12.444 7.31812 12.4411 7.26412 12.4411C6.93 12.4411 6.60994 12.592 6.3945 12.8583C6.15375 13.156 5.46863 13.8206 4.65919 14.3091C4.87856 13.7977 5.05012 13.2246 5.06194 12.6337C5.06531 12.5971 5.067 12.56 5.067 12.5286C5.067 12.0989 4.83019 11.7063 4.45388 11.5109C2.36925 10.4297 1.125 8.68971 1.125 6.85714C1.125 3.70629 4.6575 1.14286 9 1.14286C13.3414 1.14286 16.875 3.70629 16.875 6.85714C16.875 10.008 13.3419 12.5714 9 12.5714Z",
    fill: "#7F7F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.f7b45ee8.svg";
export { ForwardRef as ReactComponent };